
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/irac-legal-writing",
      function () {
        return require("private-next-pages/insights/irac-legal-writing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/irac-legal-writing"])
      });
    }
  